import { getCommonClassName } from './classname.js';

function getSizeProps(size) {
  var COMMON_SIZE_CLASS_NAMES = getCommonClassName().SIZE;
  if (typeof size === "undefined") {
    return {};
  }
  if (!(size in COMMON_SIZE_CLASS_NAMES)) {
    return {
      className: "",
      style: {
        fontSize: typeof size === "number" ? "".concat(size, "px") : size
      }
    };
  }
  return {
    className: COMMON_SIZE_CLASS_NAMES[size],
    style: {}
  };
}

export default getSizeProps;
//# sourceMappingURL=size-props.js.map
